import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { updateGlobalState } from "../state/global/slice";
import { isValidNotification } from "../utils/notificationUtils";

const useWebSocket = (url) => {
  const dispatch = useDispatch();
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const [socket, setSocket] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const sendMessage = useCallback(
    (message) => {
      if (socket?.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
      }
    },
    [socket]
  );

  useEffect(() => {
    const ws = new WebSocket(url);

    ws.onopen = () => {
      // console.log("WebSocket connected");
    };

    ws.onmessage = (event) => {
      try {
        const newNotification = JSON.parse(event.data);
        // Only add notification if it has valid data
        if (isValidNotification(newNotification)) {
          setNotifications((prev) => [newNotification]);
          // Update global state only when we have valid notifications
          updateState("notifications", [newNotification]);
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    ws.onclose = (event) => {
      // console.log("WebSocket disconnected:", event.reason);
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    setSocket(ws);

    return () => {
      ws.close();
    };
  }, [url]);

  // Only update global state when notifications change and are not empty
  useEffect(() => {
    if (notifications.length > 0) {
      updateState("notifications", notifications);
    }
  }, [notifications]);

  return { notifications, sendMessage };
};

export default useWebSocket;
